<template>
	<v-container fluid class="grey lighten-5">
		<v-container grid-list-lg>
			<v-row>
				<v-col>
					<h1 class="font-weight-black black--text text-xs-center my-1">نسخه های پازار پلاس</h1>
					<h3 class="font-weight-black black--text text-xs-center my-1">تمامی قیمتها بدون احتساب ارزش افزوده
						درج گردیده‌اند</h3>
				</v-col>
			</v-row>
			<v-row justify-right row wrap class="good-cards">
				<v-col xs="12" sm="6" md="4" v-for="(item, idx) in plusTypes" :key="idx">
					<v-hover>
						<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
							<v-responsive>
								<v-img :src="item.image" height="300">
									<!-- <br /> -->
									<!-- <v-container fill-height fluid>
										<v-row fill-height>
											<v-col xs="12" align-end flexbox></v-col>
										</v-row>
									</v-container> -->
								</v-img>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-center mb-1">{{ item.text }}</h2>
								</div>
								<v-divider></v-divider>
								<h3 class="font-weight-thin black--text text-xs-center mb-1">{{ item.desc }}</h3>
								<br />
								<v-spacer></v-spacer>
								<h4 class="font-weight-bold black--text text-left mb-0">{{ item.price }}</h4>
							</v-card-text>

							<v-card-actions>
								<v-btn text color="grey darken-2 "
									class="font-weight-thin black--text text-xs-center mb-0" :to="item.info">اطلاعات
									بیشتر</v-btn>

								<v-spacer></v-spacer>
								<v-btn text color="grey darken-2"
									class="font-weight-thin black--text text-xs-center mb-0"
									:to="item.link">خرید</v-btn>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
		<p>&nbsp;</p>
	</v-container>
</template>

<script>
export default {
	name: "PlusCards",
	computed: {
		plusTypes() {
			return this.$store.state.plusTypes;
		},
	},
};
</script>
